import { LOCALES } from "~/constants/i18n";
import { RouteBase } from "~/constants/request";

import { getLinkUrl } from "./locales";

export const getProductLinkBySlug = (
  locale: LOCALES,
  slug?: string | null,
): string | undefined => {
  if (!slug) {
    return undefined;
  }

  return getLinkUrl(locale, `${RouteBase.PDP}/${slug}`);
};
